export default __webpack_public_path__ + "static/congratulations-b9e5a527a708dd775d87e077eb33ca57.jpg";